import * as React from "react";
import { SVGProps } from "react";

const Everipedia = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 506 426"
    {...props}
  >
    <style>
      {
        ".st0{fill:#ff5caa}.st1,.st2{fill:none;stroke:#103849;stroke-linejoin:round;stroke-miterlimit:10}.st1{stroke-width:10.667;stroke-linecap:round}.st2{stroke-width:9.333}"
      }
    </style>
    <path
      d="M475.4 259.6c0 9.8-1.8 19.2-5.1 27.9-11.3 29.6-39.9 50.6-73.4 50.6-34.3 0-63.5-22-74.2-52.7-63.4 4.6-99.7-23.8-114.8-77.8-38.1-10.4-66.1-45.2-66.1-86.6 0-26.8 11.7-50.8 30.3-67.2 15.8-14 36.6-22.5 59.4-22.5 26.1 0 49.6 11.1 66 29 11-7.2 24.2-11.4 38.3-11.4 9.9 0 19.3 2 27.8 5.7 24.7 10.6 42 35 42.4 63.5v2.2c3.6-.8 7.3-1.2 11.1-1.2 17.1 0 32.3 8.2 41.9 20.9 6.6 8.8 10.6 19.7 10.6 31.6 0 12.3-4.3 24.2-12.2 33.6-.6.7-1.2 1.4-1.9 2.1 12.3 13.9 19.9 32.2 19.9 52.3"
      className="st0"
    />
    <path
      d="M334.9 114.7a86.46 86.46 0 0 0-22.9 58.7c0 47.9 38.8 86.7 86.7 86.7 6.2 0 12.3-.7 18.4-2M227.7 86.7c2.2 31.3 28.3 56 60.1 56m95.9-11.6c6.4-5.4 14.1-9.1 22.3-10.8m-108.5-60c-10.1 6.6-18.4 15.7-24 26.4"
      className="st1"
    />
    <path
      d="M475.4 259.6c0 43.4-35.2 78.5-78.5 78.5-34.3 0-63.5-22-74.2-52.7-63.4 4.6-99.7-23.8-114.8-77.8-38.1-10.4-66.1-45.2-66.1-86.6 0-49.5 40.2-89.7 89.7-89.7 26.1 0 49.6 11.1 66 29 11-7.2 24.2-11.4 38.3-11.4 38.8 0 70.2 31.4 70.2 70.2v1.2c3.6-.8 7.3-1.2 11.1-1.2 29 0 52.4 23.5 52.4 52.5 0 13.8-5.3 26.4-14.1 35.8 12.4 13.8 20 32.1 20 52.2z"
      className="st2"
    />
    <path
      d="M455.4 207.3s-6.1-6.3-14.4-12.9M221.3 349.7c-3.4-7.2-5.6-14.9-6.5-22.8"
      className="st1"
    />
    <path
      d="M375.2 295.1c2.8 7.7 4.2 15.8 4.2 24 0 42.1-37 76.2-82.6 76.2-33.8 0-62.9-18.8-75.6-45.6-10.5 7.1-23.1 11.3-36.6 11.3-30.3 0-55.9-20.9-64-49.4-5.7 1.4-11.6 2.1-17.5 2.1-39.6 0-71.8-32.1-71.8-71.8 0-30.5 19-56.5 45.7-66.9-1.1-4.4-1.6-8.9-1.6-13.5 0-36 33.4-65.1 74.6-65.1 23.7 0 44.8 9.6 58.5 24.6 11-5.9 23.6-9.3 37.1-9.3 41.8 0 75.6 32.4 75.6 72.3 0 .9 0 1.9-.1 2.8 34.5 6.3 60.7 38 60.7 76.1.1 11.6-2.3 22.4-6.6 32.2"
      className="st0"
    />
    <path
      d="M348.5 259.6c12.3 9.1 21.7 21.4 26.8 35.5m-254.7 16.5c-1.7-6.1-2.6-12.4-2.6-19.1 0-27 15.2-50.3 37.2-61.5m-59.4-60.5c-6.5.7-12.8 2.2-18.7 4.5m131.5-54h0m0 0c-9.4 5.1-17.5 12-23.9 20.2"
      className="st1"
    />
    <path
      d="M375.2 295.1c2.8 7.7 4.2 15.8 4.2 24 0 42.1-37 76.2-82.6 76.2-33.8 0-62.9-18.8-75.6-45.6-10.5 7.1-23.1 11.3-36.6 11.3-30.3 0-55.9-20.9-64-49.4-5.7 1.4-11.6 2.1-17.5 2.1-39.6 0-71.8-32.1-71.8-71.8 0-30.5 19-56.5 45.7-66.9-1.1-4.4-1.6-8.9-1.6-13.5 0-36 33.4-65.1 74.6-65.1 23.7 0 44.8 9.6 58.5 24.6 11-5.9 23.6-9.3 37.1-9.3 41.8 0 75.6 32.4 75.6 72.3 0 .9 0 1.9-.1 2.8 34.5 6.3 60.7 38 60.7 76.1.1 11.6-2.3 22.4-6.6 32.2z"
      className="st2"
    />
    <path
      d="M256.7 208.4c13.3-14 31.6-22.6 51.9-22.6 4.3 0 8.5.4 12.7 1.1m-4.9 90.9c-10.5 13.1-26.6 21.5-44.6 21.5-31.5 0-57.1-25.6-57.1-57.1 0-13.2 4.5-25.9 12.9-36.1"
      className="st1"
    />
    <path
      d="M297.1 327.5c0-11.2-2.8-21.8-7.8-31M177.8 291c9.4-13.9 24.1-24 41.1-27.5M76 242c7.2-2.9 14.9-4.3 22.7-4.3 12.5 0 24.7 3.8 34.9 10.9m59.8-59.2c-3.9 1.1-8 1.8-12.3 1.8-11.3 0-22.1-4.4-30.2-12.3m229.8 7.7c6-4.5 13.2-6.9 20.7-6.9 2.1 0 4.1.2 6.2.5"
      className="st1"
    />
    <path
      fill="none"
      stroke="#103849"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={18.667}
      d="M461.6 207.3c8.2-10.1 12.6-22.7 12.6-35.8 0-31.5-25.6-57.1-57.1-57.1-2.2 0-4.4.1-6.6.4-2.2-39.3-34.9-70.6-74.7-70.6-13.3 0-26.2 3.5-37.5 10.1-17.7-17.7-41.7-27.6-66.7-27.7-42 0-77.6 27.5-89.8 65.5-39.8 3.7-70.9 33.4-70.9 69.4 0 3.6.3 7.2.9 10.7-27.5 12.3-45.1 39.3-45.1 69.7 0 42.2 34.3 76.5 76.5 76.5 4.8 0 9.6-.4 14.3-1.3 10 28.8 37 48.6 67.1 48.6 12.2 0 24.2-3.2 34.8-9.3 14.9 26.7 44.7 43.6 77.4 43.6 39.8 0 73.5-24.9 83.9-58.8 5.2 1 10.6 1.6 16.1 1.6 45.9 0 83.2-37.3 83.2-83.2 0-19.1-6.5-37.5-18.4-52.3z"
    />
    <path
      fill="#f0f0f0"
      d="M231.5 0c-24.6 0-48.4 7.3-68.6 21.2-17.4 12-31.3 28.2-40.4 47.1-44.5 10.9-76.3 46.6-78.3 89C16.7 176.4 0 207.9 0 241.9 0 298.2 45.3 344.1 101.3 345c17.7 29.1 49.2 47.3 83.3 47.3 8.7 0 17.2-1.2 25.5-3.4 21.5 23.9 53 37.8 86.7 37.8 22.9 0 45-6.5 64.1-18.7 15.5-10 27.9-23.1 36.6-38.5 60.3-.3 109.2-49.5 109.2-109.9 0-18.6-4.7-36.7-13.6-52.9 5.1-11 7.7-23 7.7-35.1 0-22-8.5-42.8-23.8-58.5-12.1-12.4-27.5-20.6-44.2-23.8-5.6-18.3-16.5-34.8-31.2-47.4-18.4-15.6-41.7-24.2-65.8-24.2-11.2 0-22.5 1.9-33.1 5.6C282 8.2 257.1 0 231.5 0zm0 17.3c25 0 49.5 9.3 68.3 25.7 11.3-5.3 23.6-8.1 36-8.1 41.5 0 76.3 30.2 83 70.2 35.8.9 64.7 30.4 64.7 66.4 0 12.6-3.6 25-10.4 35.7 10.5 15.3 16.2 33.7 16.2 52.4 0 51-41.5 92.5-92.5 92.5-3.3 0-6.6-.2-9.9-.5-14.2 34.4-50.1 57.7-90.1 57.7-32.9 0-63.1-15.4-80.8-40.8-9.9 4.3-20.6 6.5-31.4 6.5-31.5 0-60-18.9-73.1-47.7-2.8.3-5.6.4-8.4.4-47.3 0-85.8-38.5-85.8-85.8 0-31.4 17.2-60.2 44.3-75.1-.1-1.8-.2-3.5-.2-5.3 0-38.8 31.1-71.4 73.3-77.9 15.5-39.9 53.6-66.3 96.8-66.3"
    />
  </svg>
);

export default Everipedia;
